import { render } from "./EndingStep.vue?vue&type=template&id=1cdaff0d&scoped=true"
import script from "./EndingStep.vue?vue&type=script&lang=js"
export * from "./EndingStep.vue?vue&type=script&lang=js"

import "./EndingStep.vue?vue&type=style&index=0&id=1cdaff0d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdaff0d"]])

export default __exports__